var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = Object.create(null);
    }
    EventEmitter.prototype.on = function (instanceEvent, handler) {
        if (!this.listeners[instanceEvent]) {
            this.listeners[instanceEvent] = [];
        }
        this.listeners[instanceEvent].push(handler);
    };
    EventEmitter.prototype.off = function (instanceEvent, handler) {
        if (this.listeners[instanceEvent]) {
            this.listeners[instanceEvent] = this.listeners[instanceEvent].filter(function (listener) { return listener !== handler; });
        }
    };
    EventEmitter.prototype.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var handlers = this.listeners[eventName];
        if (handlers) {
            for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
                var handler = handlers_1[_a];
                handler.apply(void 0, args);
            }
        }
    };
    return EventEmitter;
}());
export { EventEmitter };
//# sourceMappingURL=event-emitter.js.map